"use client";

import { Box, Spinner } from "@chakra-ui/react";
import { Search, Text } from "@/components/ui";
import { useThemeTokens } from "@/lib/theme/tokens";

const visuallyHidden = {
  position: "absolute",
  width: "1px",
  height: "1px",
  padding: "0",
  margin: "-1px",
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  borderWidth: "0",
} as const;

export function PublicListingSearchField({
  value,
  onChange,
  placeholder,
  description,
  describedById,
  isPending = false,
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  description: string;
  describedById: string;
  isPending?: boolean;
}) {
  const theme = useThemeTokens();

  return (
    <Box w="100%" minW={0} overflow="hidden" position="relative">
      <Search
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        aria-describedby={describedById}
        minW={0}
        overflow="hidden"
      />
      {isPending ? (
        <Box
          position="absolute"
          right="12px"
          top="50%"
          transform="translateY(-50%)"
          pointerEvents="none"
        >
          <Spinner size="sm" color={theme.accent.primary} />
        </Box>
      ) : null}
      <Box id={describedById} sx={visuallyHidden}>
        {description}
      </Box>
    </Box>
  );
}

export function PublicListingCount({
  count,
  singular,
  plural,
}: {
  count: number;
  singular: string;
  plural: string;
}) {
  const label =
    count === 1 ? `1 ${singular} found` : `${count} ${plural} found`;

  return (
    <>
      <Box role="status" aria-live="polite" aria-atomic="true" sx={visuallyHidden}>
        {label}
      </Box>
      <Text
        variant="tertiary"
        fontSize="xs"
        textTransform="uppercase"
        letterSpacing="0.1em"
        fontWeight="500"
      >
        {label}
      </Text>
    </>
  );
}
